import { packingTrackingHistoryApi } from "@/main/api";
import { Controls } from "@/main/services/constants/constantsControl";
import { FileTypeContentEnum } from "@/main/services/enum/FileTypeContentEnum";
import { ProcurementStatusEnum } from "@/main/services/enum/StatusProcurement";
import { isShowControlByElementId } from "@/main/services/utils";
import { downloadAnyFile, downloadPdfFile } from "@/main/services/utilsFile";
import { userIsAdmin, userIsBodyshop, userIsBuyer } from "@/main/services/utilsUser";

interface IIsReturnable {
	guidCompany: string;
	idCompanyStatus: ProcurementStatusEnum;
	bodyshopResponseTime?: boolean;
}

export const isReturnablePart = ({ guidCompany, idCompanyStatus, bodyshopResponseTime = true }: IIsReturnable) => {
	const isBodyshopUser = userIsBodyshop();
	const isAdministratorUser = userIsAdmin();
	const isBuyer = userIsBuyer(guidCompany);

	const statusToReturn = [
		ProcurementStatusEnum.Received,
		ProcurementStatusEnum.Delivered,
		ProcurementStatusEnum.Invoiced,
	];

	const isReturnableStatus = statusToReturn.includes(idCompanyStatus);

	if (isBodyshopUser) {
		const controlIdReturnApprovalProcess = isShowControlByElementId(Controls.IdReturnApprovalProcess);

		return controlIdReturnApprovalProcess && bodyshopResponseTime && isReturnableStatus;
	}

	return (
		(isAdministratorUser || isBuyer) &&
		(isReturnableStatus || (idCompanyStatus === ProcurementStatusEnum.Paid && isAdministratorUser))
	);
};

export async function handleDownloadPDf(trackingCode: number | string, setLoading: (value: boolean) => void) {
	setLoading(true);
	const request = {
		packingTrackingCode: String(trackingCode),
		is4x6: true,
	};

	packingTrackingHistoryApi
		.getPrintPdfTag(request)
		.then((res) => {
			const resData = res.data.result;
			downloadPdfFile(resData.content, `tag${trackingCode}.pdf`);
		})
		.catch(() => {})
		.finally(() => setLoading(false));
}

export async function handleDownloadZPL(trackingCode: number | string, setLoading: (value: boolean) => void) {
	setLoading(true);
	packingTrackingHistoryApi
		.getPrintZplTag(String(trackingCode))
		.then((res) => {
			const resData = res.data.result;
			downloadAnyFile(resData.content, `tag${trackingCode}.zpl`, FileTypeContentEnum.ZPL);
		})
		.catch(() => {})
		.finally(() => setLoading(false));
}
